module.exports = __webpack_public_path__ + "img/image132.e160488f.png";